import 'whatwg-fetch';

export default class FormsHandler {
	rootEl: any;
	formEls = [];

	redirectUrl: String;

	constructor(formEl: Element) {
		this.rootEl = formEl;

		this.init();
	}

	init() {
		this.hydrateForms();
		this.attachListeners();
		this.loading(false);
	}

	handleSubmit = (e) => {
		e.preventDefault();

		const form = e.target;
		const passed = this.validateForm(form);

		if (passed) {

			const formType = form.getAttribute('data-type');

			let formData;
			if (formType === 'image') {
				formData = this.processImageForm(form, (data) => {
					const submit = this.submitForm(form, data);

					submit.then((data: any) => {
						data = JSON.parse(data);
						if (data.success) {
							window.location.href = `/contact/?submitted=true&complete=true`;
						}
					});
				});
			} else {
				formData = this.toFormData(form);

				const submit = this.submitForm(form, formData);

				submit.then((data: any) => {
					data = JSON.parse(data);
					if (data.success) {
						window.location.href = `/contact/?submitted=true&image-id=${data.id}`;
					}
				});
			}

		}
	}

	buildImageData(formData, image) {
		const newObj = new FormData();

		newObj.append('body', image);
		newObj.append('id', formData.id);
		newObj.append('filename', formData.body);
		newObj.append('type', 'image');

		return newObj;
	}

	processImageForm(form, cb) {
		const formData: any = JSON.parse(this.toJsonString(form));
		const imageInputs = form.querySelectorAll('input[type="file"]');

		const base64 = this.getBase64(imageInputs[0].files[0], (e) => {

			const imageData = this.buildImageData(formData, e.target.result);

			cb(imageData);
		});
	}

	getBase64(file, cb) {
		let results;
		const reader = new FileReader();

		reader.readAsDataURL(file);
		reader.onload = cb;

		reader.onerror = function (error) {
			console.log('reader error', error);
		}
	}

	loading(isLoading) {
		const loadingEl = document.getElementById("loading");

		if (isLoading) {
			loadingEl.style.display = "block";
		} else {
			loadingEl.style.display = "none";
		}
	}

	submitForm(form, data) {
		this.loading(true);

		const headers = new Headers();

		return new Promise((resolve, reject) => {

			fetch(form.action, {
				method: "POST",
				headers: headers,
				body: data
			})
				.then(resp => {
					return resp.json()
				})
				.then(data => {
					this.loading(false);

					resolve(data);
				})
				.catch(e => {
					console.error(`There was an error fetching from SalesForce ${e}`);
					this.loading(false);
					reject(false);
				})
		});
	}

	validateForm(form) {
		const requiredEls = form.querySelectorAll('.js-required');

		// Highlight field on empty value
		let passed = true;
		if (requiredEls.length) {

			// Set their state
			requiredEls.forEach(el => {
				if (el.value.length <= 0) {
					el.classList.add('error')
					passed = false;
				} else {
					el.classList.remove('error')
				}
			});
		}

		return passed;
	}

	toFormData(form) {
		const formData = new FormData();
		const elements = form.querySelectorAll("input, select, textarea");

		for (let i = 0; i < elements.length; i++) {
			if (elements[i].type === 'submit') {
				continue;
			}

			else if (elements[i].name === 'redirect') {
				this.redirectUrl = elements[i].value;
				continue;
			}

			const element = elements[i];
			const name = element.name;
			const val = element.value;

			if (name) {
				// formData[name] = val;
				formData.append(name, val);
			}
		}

		return formData;
	}

	toJsonString(form) {
		const obj = {};
		const elements = form.querySelectorAll("input, select, textarea");

		for (let i = 0; i < elements.length; i++) {
			if (elements[i].type === 'submit') {
				continue;
			}

			else if (elements[i].name === 'redirect') {
				this.redirectUrl = elements[i].value;
				continue;
			}

			const element = elements[i];
			const name = element.name;
			const val = element.value;

			if (name) {
				obj[name] = val;
			}
		}

		return JSON.stringify(obj);
	}

	attachListeners() {
		const { formEls } = this;

		formEls.forEach(form => {
			form.addEventListener('submit', this.handleSubmit);
		});
	}

	hydrateForms() {
		const formEls = Array.from(this.rootEl.querySelectorAll('form'));

		this.formEls = [...formEls];
	}
}